import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

interface Props {
  open: boolean;
  propertyName: string;
  initialDate: string;
  onClose: (newDate: string) => void;
}

export const MoveInDateModal: React.FC<Props> = ({
  open,
  propertyName,
  initialDate,
  onClose,
}) => {
  const [date, setDate] = useState(initialDate);

  const minDate = (() => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  })();

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Welcome to {propertyName}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          To see available units and pricing tailored to your plans, please
          choose your desired move-in date.
        </Typography>
        <TextField
          label="Desired Move-In Date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: minDate }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={!date}
          onClick={() => onClose(date)}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
